import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Resource upload API
 */
class SplitMethodApi extends ApiBase {
  /**
   * create Split Method
   * @param {*} formData Form Data
   */
  async create(formData) {
    // Get headers for form-data split method
    const headers = this.getHeaders();

    const request = {
      url: `${this.API_URL}/splitmethod`,
      method: 'POST',
      headers: headers,
      data: formData
    };

    const response = await axios.request(request);

    if (response.status !== 201) {
      throw new Error(response.statusText);
    }
    return response.data;
  }

  /**
   * Update Split Method
   * @param splitType
   * @param {*} formData
   */
  async update(splitType, formData) {
    // Get headers for form-data
    const headers = this.getHeaders();

    const request = {
      url: `${this.API_URL}/splitmethod?splitType=${splitType}`,
      headers: headers,
      method: 'PUT',
      data: formData
    };

    const response = await axios.request(request);

    return response.data;
  }
}
export default new SplitMethodApi();
